function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { VMenuItem } from '@cloud-sn/v-menu';
import { isSameTypeVNode, getVNodeText } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Tooltip from '../tooltip';

function isSubMenuNode(vm) {
  return isSameTypeVNode(vm.$vnode, 'isSubMenuType');
}

function isTopMenuItem(vm) {
  var ret = true;
  var parent = vm.$parent;

  while (parent) {
    if (isSubMenuNode(parent)) {
      ret = false;
      break;
    }

    parent = parent.$parent;
  }

  return ret;
}

export default {
  name: buildComponentName('MenuItem'),
  inject: {
    menuWrap: {
      default: {}
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isWrap: true
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      return this.menuWrap.prefixCls;
    },
    inlineCollapsed: function inlineCollapsed() {
      return this.menuWrap.inlineCollapsed;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        $attrs = this.$attrs,
        slotDefault = this.$slots.default,
        inlineCollapsed = this.inlineCollapsed;
    var item = h(VMenuItem, {
      "props": _objectSpread({}, $props),
      "attrs": _objectSpread({}, $attrs)
    }, [slotDefault]);
    return inlineCollapsed && isTopMenuItem(this) ? h(Tooltip, {
      "attrs": {
        "placement": "right"
      }
    }, [h("template", {
      "slot": "content"
    }, [getVNodeText(slotDefault).join(' ')]), item]) : item;
  }
};